import {
  changeProperty,
  closeSettings,
  FIELD_ERROR_MESSAGES,
  filterSelected,
  getNumberOfActivatedProjects,
  loadTemplateLanguages,
  NUMBER_OF_PROJECTS_TO_ATIVATE,
  submitSettings,
  SURVEY_IS_COPY,
  SURVEY_IS_NEW,
  SURVEY_SHOW_PROPERTY_DIALOG,
  TEMPLATE_LANGUAGES
} from "../../../ducks/surveySettings";
import {
  saveSurveySettings,
  SURVEY_ACTIVATION_PERIOD,
  SURVEY_FUNDING_AREA,
  SURVEY_IDENTIFIER,
  SURVEY_LANGUAGE,
  SURVEY_NAME,
  SURVEY_PROGRAM,
  SURVEY_PROGRAM_INSTANCE,
  SURVEY_PROJECT
} from "../../../ducks/survey";

import SurveySettings from "./SurveySettings";
import { TEMPLATE_LIST } from "../../../ducks/templatelist";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  return {
    surveyName: state.surveySettings[SURVEY_NAME],
    identifier: state.surveySettings[SURVEY_IDENTIFIER],
    showDialog: state.surveySettings[SURVEY_SHOW_PROPERTY_DIALOG],
    isNew: state.surveySettings[SURVEY_IS_NEW],
    surveyIsCopy: state.surveySettings[SURVEY_IS_COPY],
    fieldErrorMessages: state.surveySettings[FIELD_ERROR_MESSAGES],
    fundingArea: state.surveySettings[SURVEY_FUNDING_AREA],
    program: state.surveySettings[SURVEY_PROGRAM],
    programInstance: state.surveySettings[SURVEY_PROGRAM_INSTANCE],
    project: state.surveySettings[SURVEY_PROJECT],
    surveyLanguage: state.surveySettings[SURVEY_LANGUAGE],
    templateList: state.templatelist[TEMPLATE_LIST],
    templateLanguages: state.surveySettings[TEMPLATE_LANGUAGES],
    surveyActivationPeriod: state.surveySettings[SURVEY_ACTIVATION_PERIOD],
    numberOfProjectsToActivate: state.surveySettings[NUMBER_OF_PROJECTS_TO_ATIVATE]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      saveSurveySettings,
      closeSettings,
      submitSettings,
      changeProperty,
      getNumberOfActivatedProjects,
      filterSelected,
      loadTemplateLanguages
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveySettings);
